import { render, staticRenderFns } from "./Deals.vue?vue&type=template&id=1fc664e8&"
import script from "./Deals.vue?vue&type=script&lang=js&"
export * from "./Deals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports